import { Checkbox } from '../checkbox'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import { infoLocalizedMessages } from '../account/my_info'
import { promoMessages } from 'spa/pages/marketing/localizedMessages'
import { promoStringResource } from 'spa/shared/utils'
import { signup } from 'spa/action_creators/current_user'
import { SpinnerButton } from 'spa/components/button'
import { TextInput } from 'spa/components/text_input'
import { TextStyle } from '../typography'
import { useDispatch, useSelector } from 'react-redux'
import Form from 'spa/components/form'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import styles from './styles'

function PromoSignUp({ price = 0, currency = '$', formInputRef, offerName }) {
  const dispatch = useDispatch()

  const isSigningUp = useSelector(state => state.isSigningUp)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [permissionToSendEmail, setPermissionToSendEmail] = useState(true)

  useEffect(() => {
    setFirstName('')
    setLastName('')
    setEmail('')
    setPassword('')
    setPermissionToSendEmail(true)
  }, [
    setFirstName,
    setLastName,
    setEmail,
    setPassword,
    setPermissionToSendEmail,
  ])

  const isDisabled =
    !firstName || !lastName || !email || !password || isSigningUp

  const submit = useCallback(
    e => {
      e.preventDefault()
      if (!isDisabled) {
        dispatch(
          signup({
            email,
            password,
            firstName,
            lastName,
            permissionToSendEmail,
          })
        )
      }
    },
    [isDisabled, firstName, lastName, email, password, permissionToSendEmail]
  )

  const getPromoStringResource = (resource, values) => {
    return promoStringResource(resource, values, offerName)
  }

  return (
    <Form className={styles.signUpForm} onSubmit={submit}>
      <div className={styles.title}>
        <span
          dangerouslySetInnerHTML={{
            __html: getPromoStringResource(promoMessages.signup_title, {
              price,
              currency,
            }),
          }}
        />
        <div className={styles.subtitle}>
          {getPromoStringResource(promoMessages.signup_subtitle)}
        </div>
      </div>
      <div>
        <TextStyle className={styles.label} color="white" variant="label">
          {getPromoStringResource(infoLocalizedMessages.firstName)}
        </TextStyle>
        <TextInput
          className={styles.input}
          data-test-id="signup.firstName"
          inputRef={formInputRef}
          onChange={e => setFirstName(e.currentTarget.value)}
          placeholder={getPromoStringResource(promoMessages.signup_firstname)}
          value={firstName}
        />
      </div>
      <div>
        <TextStyle className={styles.label} color="white" variant="label">
          {getPromoStringResource(infoLocalizedMessages.lastName)}
        </TextStyle>
        <TextInput
          className={styles.input}
          data-test-id="signup.lastName"
          onChange={e => setLastName(e.currentTarget.value)}
          placeholder={getPromoStringResource(promoMessages.signup_lastname)}
          value={lastName}
        />
      </div>
      <div>
        <TextStyle className={styles.label} color="white" variant="label">
          {getPromoStringResource(infoLocalizedMessages.email)}
        </TextStyle>
        <TextInput
          className={styles.input}
          data-test-id="signup.email"
          onChange={e => setEmail(e.currentTarget.value)}
          placeholder={getPromoStringResource(promoMessages.signup_email)}
          value={email}
        />
      </div>
      <div>
        <TextStyle className={styles.label} color="white" variant="label">
          {getPromoStringResource(infoLocalizedMessages.password)}
        </TextStyle>
        <TextInput
          className={styles.input}
          data-test-id="signup.password"
          onChange={e => setPassword(e.currentTarget.value)}
          placeholder={getPromoStringResource(promoMessages.signup_password)}
          type="password"
          value={password}
        />
      </div>
      <div className={styles.email_permission}>
        <Checkbox
          className={styles.checkbox}
          onChange={() => setPermissionToSendEmail(!permissionToSendEmail)}
          selected={permissionToSendEmail}
        ></Checkbox>
        <FormattedHTMLMessage
          defaultMessage="By checking this box, you agree to receive marketing emails, including updates, promotions, and offers, from DJcity. You may unsubscribe at any time. For more information, please see our <a href='/privacy-policy'>Privacy Policy</a>"
          id="djcity.account.email_permission"
        />
      </div>
      <div className={styles.row}>
        <SpinnerButton
          centered="centered"
          className={styles.spinnerButton}
          disabled={isDisabled}
          loading={isSigningUp}
          type="submit"
        >
          {getPromoStringResource({
            defaultMessage: 'Join now',
            id: 'djcity.common.marketing.promo.signup.button',
          })}
        </SpinnerButton>
      </div>
    </Form>
  )
}

PromoSignUp.propTypes = {
  currency: PropTypes.string.isRequired,
  formInputRef: PropTypes.any,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  offerName: PropTypes.string,
  price: PropTypes.string.isRequired,
}

export default injectIntl(PromoSignUp)
